export default "/react/yandexBussinessIcon-f94303db.svg";